// Phase 83z.61 — Sticky banner shown across referee pages whenever there
// is at least one failed / conflict event in the offline queue. Click →
// `/referee/pending` so the trọng tài can inspect + retry.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { WarningCircle, ArrowRight } from "@phosphor-icons/react";
import { subscribe } from "../../lib/refereeSyncEngine";
import { listEvents } from "../../lib/refereeOfflineStore";

export default function RefereeOfflineBanner() {
  const [bad, setBad] = useState(0);
  const [conflict, setConflict] = useState(0);

  useEffect(() => {
    let mounted = true;
    const refresh = async () => {
      const ev = await listEvents();
      if (!mounted) return;
      setBad(ev.filter((e) => e.status === "failed").length);
      setConflict(ev.filter((e) => e.status === "conflict").length);
    };
    refresh();
    const unsub = subscribe(() => refresh());
    return () => { mounted = false; unsub(); };
  }, []);

  if (!bad && !conflict) return null;

  const parts = [];
  if (bad) parts.push(`${bad} sự kiện chưa gửi được`);
  if (conflict) parts.push(`${conflict} trận bị xung đột`);

  return (
    <div
      role="alert"
      data-testid="referee-offline-banner"
      className="sticky top-0 z-40 bg-rose-600/95 text-white px-4 py-2 flex items-center gap-2 text-sm font-medium shadow-lg backdrop-blur"
    >
      <WarningCircle size={18} weight="fill" />
      <span className="flex-1 truncate">
        {parts.join(" · ")} — mở &quot;Hàng đợi đồng bộ&quot; để thử lại hoặc bỏ qua.
      </span>
      <Link
        to="/referee/pending"
        className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/20 hover:bg-white/30 transition text-[12px] font-bold"
        data-testid="referee-offline-banner-link"
      >
        Xem
        <ArrowRight size={12} weight="bold" />
      </Link>
    </div>
  );
}
